import Vue from 'vue'
import VueRouter, { RawLocation, Route, RouteConfig } from 'vue-router'
import homeRouting from '@/modules/home/routing'
import accountRouting from '@/modules/account/routing'
import settingsRouting from '@/modules/settings/routing'
import errorRouting from '@/modules/error/routing'

import i18n from '@/i18n'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location: RawLocation): Promise<Route> {
    return new Promise((resolve, reject) => {
        originalPush.call(this, location, () => {
            resolve(this.currentRoute)
        }, (error) => {
            if (error.name === 'NavigationDuplicated') {
                resolve(this.currentRoute)
            } else {
                reject(error)
            }
        })
    })
}

const routes: Array<RouteConfig> = [
    {
        path: '*',
        meta: { title: i18n.t('notFound') },
        component: () => import('@/shared/views/NotFound.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes.concat(homeRouting, accountRouting, settingsRouting, errorRouting)
})

router.beforeEach((to, from, next) => {
    document.title = to.meta?.title
    next()
})

export default router
